export default __webpack_public_path__ + "static/media/disable_leaderboard.819c7106.svg";